import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

export default function ObjectArrayEditor({ value = [], onValueChange, stopEditing = () => {}, values, displayKey, t, width, autoFocus = true }) {
    const ref = useRef(null);

    // Mapping pour react-select { value, label }
    const options = values.map(v => ({ value: v.id, label: t(v[displayKey])}));

    const [selectedOptions, setSelectedOptions] = useState(
        options.filter(o => value.map(v => v.id).includes(o.value))
    );

    useEffect(() => {
        // Focus sur le select à l'ouverture
        if (autoFocus) ref.current?.focus();
    }, []);

    const handleChange = (selected) => {
        const newSelected = selected || [];
        setSelectedOptions(newSelected);

        // Compare IDs of previous value vs new value
        const prevIds = value.map(v => v.id).sort();
        const newIds = newSelected.map(s => s.value).sort();

        const isEqual =
            prevIds.length === newIds.length &&
            prevIds.every((id, index) => id === newIds[index]);

        if (isEqual) return; // no change, skip onValueChange

        const newValue = values.filter(v => newIds.includes(v.id));
        onValueChange(newValue);
    };

    return (
        <div style={{ width: "100%" }}>
            <Select
                ref={ref}
                isMulti
                autoFocus={autoFocus}
                classNamePrefix="ag-select"
                options={options}
                value={selectedOptions}
                onChange={handleChange}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    container: (provided) => ({ ...provided, margin: "1px", minWidth: width, width: "100%" }),
                    valueContainer: (provided) => ({
                        ...provided,
                        padding: '0 4px',
                        flexWrap: 'wrap',
                        overflowY: 'auto',
                        //height: '44px',
                        maxHeight: "40px",
                        lineHeight: '16px',
                    }),
                    /*valueContainer: (base) => {
                        return {
                            ...base,
                            maxHeight: "100px",
                            overflowY: "auto",
                            height: '44px',
                        }
                    },*/
                    control: (provided) => ({ ...provided, height: '44px' }),
                    indicatorsContainer: (provided) => ({ ...provided, height: '44px',  alignSelf: 'flex-start',  paddingTop: '2px' }),
                    menu: (provided) => ({ ...provided, position: 'absolute', zIndex: 9999, top: '-4px' }),
                    option: (provided) => ({...provided, cursor: 'pointer'}),
                    multiValue: (provided) => {
                        return {
                            ...provided,
                            height: '20px',
                            flexShrink: 0,
                            border: '1px solid #c2e0ff',
                            backgroundColor: '#ebf5ff',
                            display: 'flex',
                            alignItems: 'center',
                        };
                    },
                    multiValueLabel: (provided) => {
                        return ({
                            ...provided,
                            color: '#007eff',
                        })
                    },
                    multiValueRemove: (provided) => {
                        return {
                            ...provided,
                            display: 'flex',
                            ':hover': {
                                ...provided[':hover'],
                                backgroundColor: '#d5dfe9',
                                color: 'black'
                            }
                        }
                    }
                }}
            />
        </div>
    );
}
